<template>
    <div>    
        <eod-dialog v-if="isCreateCompanyDialogVisible" v-model="isCreateCompanyDialogVisible" width="1200" title="Bedrijf toevoegen" icon="mdi-plus" iconColor="primary" okText="Toevoegen" @okAction="saveCompany" :loading="isCreateCompanyDialogLoading">
                    <eod-company-detail class="mt-4" compact v-model="createCompany"></eod-company-detail>
                </eod-dialog>
                <v-row>
                    <v-col cols="12" :md="isAdvanced?8:12">
                        <eod-card :outlined="compact">
                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <eod-text-field dense :value="value.name" @input="val => updateProperty('name', val)" :rules="[val => $validator.required(val, 'Naam')]" label="Naam*" required outlined
                                            hide-details></eod-text-field>
                                    </v-col>
                                    <v-col>
                                        <eod-text-field dense :value="value.description" @input="val => updateProperty('description', val)" label="Omschrijving" outlined
                                            hide-details></eod-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <eod-object-autocomplete label="Bedrijf*" required :rules="[val => $validator.required(val, 'Bedrijf')]" v-if="value" endpoint="companies" return-object :fields="['id','name','users{id assignedRealmRoles{id name}}']" :value="value.company?value.company:null" :defaultFilter="{whereNotIn:{column:'type',array:['MANUFACTURER','SUPPLIER']}}" @input="companyChanged">
                                            <template v-slot:append-item>
                                                <v-divider></v-divider>
                                                <v-list-item dense @click="isCreateCompanyDialogVisible = true">
                                                            <v-list-item-icon>
                                                                <v-icon>mdi-plus</v-icon>
                                                            </v-list-item-icon>
                                                            <v-list-item-content>
                                                                <v-list-item-title>Bedrijf toevoegen</v-list-item-title>
                                                                <v-list-item-subtitle>Voeg een bedrijf toe wanneer u deze
                                                                    niet in de lijst vindt.</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                            </template>
                                        </eod-object-autocomplete>

                                    </v-col>
                                   <v-col>
                        <eod-autocomplete :disabled="!value.company?.id" item-value="id" item-text="name" outlined hide-details label="Standaard dienst" clearable return-object :items="services" :value="value.defaultService"  @input="val => updateProperty('defaultService', val)" info="De dienst die automatisch wordt ingevuld wanneer dit project wordt gekozen in een workflow. Alle jobs binnen dezelfde workflow-instantie gebruiken dezelfde dienst.">
                            <template v-slot:append-item>
                                <v-divider class="mb-2"></v-divider>
                                <v-list-item id="add_service" @click.stop="isCreateServiceDialogVisible = true">
                                    <v-list-item-icon>
                                        <v-icon>mdi-plus</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Nieuwe dienst aanmaken</v-list-item-title>
                                        <v-list-item-subtitle>Maak een dienst aan en voeg deze toe aan het bedrijf</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </eod-autocomplete>
                        <eod-dialog v-if="value" v-model="isCreateServiceDialogVisible" title="Dienst toevoegen" icon="mdi-plus" iconColor="primary" width="1200" @okAction="createServiceAction" okText="Toevoegen">
                            <eod-service-detail class="mt-4" outlined compact v-model="createService" hide-company></eod-service-detail>
                        </eod-dialog>
                    </v-col>
                                </v-row>
                                <v-row>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!isAdvanced" @click="isAdvanced = true" text small>Geavanceerd <v-icon right small>mdi-chevron-down</v-icon></v-btn>
                </v-row>
                            </v-card-text>
                        </eod-card>
                        
                        <eod-card v-if="isAdvanced" id="card_contacts" subtitle="Externe contacten" title="Contacten" class="mt-4" :outlined="compact" color="blue lighten-5">
                            <template v-slot:header-icon>
                                <v-avatar color="blue" size="40" class="mr-2"><v-icon dark>mdi-account</v-icon></v-avatar>
                                
                            </template>
                                    <eod-contacts header-inset flat :roles="settings.roles.contacts" :value="users" @input="val => setUsers(val)" :show-role="false"></eod-contacts>
                                </eod-card>
                        <eod-card v-if="isAdvanced" icon="mdi-account-group" id="card_employees" title="Medewerkers" subtitle="Interne medewerkers van uw organisatie" class="mt-4" :outlined="compact" color="green lighten-5">
                            <template v-slot:header-icon>
                                <v-avatar color="green" size="40" class="mr-2"><v-icon dark>mdi-account-hard-hat-outline</v-icon></v-avatar>
                                
                            </template>
                            <eod-contacts header-inset flat :roles="settings.roles.collaborators" :value="users" @input="val => setUsers(val)" :show-role="false"></eod-contacts>
                        </eod-card>
                        <eod-card v-if="isAdvanced" title="Standaard checklijst" class="mt-4" :outlined="compact">
                            <eod-checklist v-if="value && value.id" hide-checkbox :default="{projectId:value.id, category:'DEFAULT_CHECKLIST_ITEM'}"></eod-checklist>
                            <div v-else class="px-4 py-4">
                            <v-alert text dense class="grey--text mb-0">Gelieve eerst te bewaren om items toe te voegen.</v-alert>
                            </div>
                        </eod-card>
                    </v-col>
                    <v-col cols="12" md="4" v-if="isAdvanced">
                        <eod-card class="mb-4" v-if="sharepointURLTemplate" title="Koppelingen" :outlined="compact">
                            <v-card-text>
                                <v-row class="mt-2">
                                    <v-col cols="4" lg="2" xl="1">
                                        <a target="_blank" :href="$helper.replaceTags(sharepointURLTemplate, {project: value})"><v-img
                                                :src="require('@/assets/img/integrations/sharepoint.svg')" contain /></a>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions></v-card-actions>
                        </eod-card>
                        <eod-card id="card_locations" class="mb-4" :outlined="compact">
                            <template v-slot:header-title>
                                <v-badge color="grey" :content="value.locations?''+value.locations.length:'0'" inline>Locaties</v-badge>
                            </template>
                            <template v-slot:header-actions>
                                <v-btn id="btn_edit_locations" @click="editLocations" small icon><v-icon small>mdi-pencil-outline</v-icon></v-btn>
                            </template>
                            <eod-locations-map :location-filters="{where:[{column:'projectId', value:value.id}]}" v-if="value.locations && value.locations.length > 0" ratio="1.4" :value="value.locations" readonly></eod-locations-map>
                            <v-list dense>
                                <v-list-item @click="editLocations" v-for="(location, locationIndex) in value.locations" :key="locationIndex">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ location.name }}</v-list-item-title>
                                        <v-list-item-subtitle>{{location.streetAddress}}, {{location.postalCode}} {{location.locality}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <eod-dialog icon="mdi-map" iconColor="primary" @okAction="value.locations = locations;isLocationsDialogVisible=false;" title="Locaties" okText="Toepassen" width="100%" max-width="1200" v-if="isLocationsDialogVisible" v-model="isLocationsDialogVisible">
                                <template v-slot:headerActions>
                                    <v-btn id="btn_create_location" @click="$refs.locationsList.addItem()" depressed color="primary" rounded><v-icon left>mdi-plus</v-icon>Toevoegen</v-btn>
                                </template>
                                <eod-locations :location-filters="{where:[{column:'projectId', value:value.id}]}" hide-add ref="locationsList" hide-search v-model="locations"></eod-locations>
                            </eod-dialog>
                        </eod-card>
                        <eod-card :outlined="compact" title="Tags" v-if="$eod.getOrganizationSetting('tags.listId') && $eod.getOrganizationSetting('tags.listId').value">
                            <v-card-text>
                                <eod-tags deletable addable v-model="value.tags"></eod-tags>
                            </v-card-text>
                        </eod-card>
                        <eod-card :outlined="compact" class="mt-4" title="Favoriete media" v-if="value && value.id">
                            <template v-slot:header-actions>
                                <v-btn @click="$emit('changeTab', 2)" small icon><v-icon small>mdi-pencil-outline</v-icon></v-btn>
                            </template>
                            <v-card-text>
                                <eod-storage-objects-carousel :filters="[{ config:{type:'property', filter:'projectId', operator:'='}, result:{id: value.id} }, {config:{type:'property',filter:'isFavorite',operator:'='}, result:{id:'1'}}]"></eod-storage-objects-carousel>
                            </v-card-text>
                        </eod-card>
                        <eod-card class="mt-4" title="Integraties IDs">
                            <v-card-text>
                                <eod-integration-ids v-if="value.id" :itemId="value.id" endpoint="projects"></eod-integration-ids>
                                <v-alert v-else type="info" text>Gelieve eerst te bewaren</v-alert>
                            </v-card-text>
                        </eod-card>
                    </v-col>
                </v-row>
                </div>
</template>
<script>
import eodTags from './eod-tags.vue';
import eodContacts from './eod-contacts.vue';
import eodLocations from './eod-locations.vue';
import eodObjectAutocomplete from './eod-object-autocomplete.vue';
import eodObjectsTreeviewDetail from './eod-objects-treeview-detail.vue';
import eodServiceDetail from './eod-service-detail.vue';
import eodLocationsMap from './eod-locations-map.vue';
import eodStorageObjectsCarousel from './eod-storage-objects-carousel.vue';
import eodCompanyDetail from './eod-company-detail.vue';
import eodIntegrationIds from './eod-integration-ids.vue';
import eodChecklist from './eod-checklist.vue';
import Company from './../models/company.js';
import Service from './../models/service.js';

export default {
    name: 'eod-project-detail',
    components:{
        eodContacts,
        eodCompanyDetail,
        eodStorageObjectsCarousel,
        eodObjectsTreeviewDetail,
        eodObjectAutocomplete,
        eodLocationsMap,
        eodTags,
        eodLocations,
        eodIntegrationIds,
        eodChecklist,
        eodServiceDetail
    },
    props:{
        value: {
            type: Object,
            default: () => ({})
        },
        compact: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            isAdvanced: false,
            isCreateCompanyDialogVisible: false,
            isCreateCompanyDialogLoading: false,
            createCompany: {},
            isLocationsDialogVisible: false,
            locations: [],
            settings: require('./../classes/settings.js'),
            sharepointURLTemplate: null,
            isCreateServiceDialogVisible: false,
            createService: {},
            services: []
        }
    },
    mounted(){
        this.isAdvanced = !this.compact;

        let sharepointURLSetting = this.$eod.getOrganizationSetting('share.sharepoint.projects.url');
            if (sharepointURLSetting && sharepointURLSetting.value) {
                this.sharepointURLTemplate = sharepointURLSetting.value;
            }
            
        this.loadCompanyServices();
    },
    computed: {
        users: function(){
            const users = [];

            if(this.value && this.value.users){
                this.value.users.forEach(user => {
                    users.push({...user, type: 'PROJECT'});
                });
            }
            if(this.value && this.value.company && this.value.company.users){
                this.value.company.users.forEach(user => {
                    users.push({...user, type: 'COMPANY', readonly: true});
                });
            }
            return users;
        },
    },
    methods:{
        setUsers(val){
            // Only keep users of the specified type
            val = val.filter(user => user.type == 'PROJECT' || !user.type);
            this.updateProperty('users', val);
        },
        loadCompanyServices(){
            if(!this.value.company){
                return;
            }

            this.$eod.get('services', ['id', 'name'], {
                    where: [
                        {
                            'column': 'companyId',
                            'operator': '=',
                            'value': this.value.company.id
                        }
                    ]
                }).then(response => {
                    if(response.data.data.services){
                        this.services = response.data.data.services.edges;
                    }
                });
        },
        companyChanged(val){
            this.updateProperty('company', val);

            if(val && val.id){
                this.$eod.get('services', ['id', 'name'], {
                    where: [
                        {
                            'column': 'companyId',
                            'operator': '=',
                            'value': val.id
                        }
                    ]
                }).then(response => {
                    if(response.data.data.services){
                        this.services = response.data.data.services.edges;
                        if(this.services[0]){
                            this.updateProperty('defaultService', this.services[0]);
                        } else {
                            this.updateProperty('defaultService', null);
                        }
                    }
                });
            } else {
                this.updateProperty('defaultService', null);
            }
        },
        async saveCompany(){
            this.isCreateCompanyDialogLoading = true;
            if(!isNaN(this.createCompany.defaultService.id)){
                const company = new Company(this.createCompany);
                delete company.defaultService;
                const companySaveData = company.getSaveData();
                const newCompanyId = await this.$eod.save('Company', companySaveData).then(response => {
                    if(response && response.data && response.data.data && response.data.data.createCompany){
                        return response.data.data.createCompany.id;
                    }
                    return null;
                });

                if(newCompanyId){
                    const service = new Service(this.createCompany.defaultService);
                    delete service.id;
                    service.companyId = newCompanyId;
                    const serviceSaveData = service.getSaveData();
                    const newServiceId = await this.$eod.save('Service', serviceSaveData).then(response => {
                        if(response && response.data && response.data.data && response.data.data.createService){
                            return response.data.data.createService.id;
                        }
                        return null;
                    });

                    if(newServiceId){
                        await this.$eod.save('Company', {
                            id: newCompanyId,
                            defaultServiceId: newServiceId
                        });
                    }

                    this.companyChanged({id: newCompanyId});

                    this.isCreateCompanyDialogVisible = false;
                }
            }

            this.isCreateCompanyDialogLoading = false;
        },
        createServiceAction(){
            const serviceCopy = {...this.createService};
            this.setService(serviceCopy);
            this.isCreateServiceDialogVisible = false;
        },
        setService(service){
            this.services.push(service);
            this.updateProperty('defaultService', service);
        },
        editLocations(){
            this.locations = _.clone(this.value.locations);
            this.isLocationsDialogVisible = true;
        },
        updateProperty(propertyName, value){
            const val = this.value;
            val[propertyName] = value;
            this.$emit('input', val);
        },
        
    }
}
</script>